import React from 'react';

import { CustomizableLink } from '~components/common/Link';

export function RestorationDisclaimer() {
  return (
    <div className='text-base font-bold'>
      Do you have a felony conviction? Please visit{' '}
      <CustomizableLink
        href='https://campaignlegal.org/restoreyourvote'
        target='_blank'
        rel='noopener'
        title='Restore Your Vote'
      >
        Restore Your Vote
      </CustomizableLink>{' '}
      to determine your eligibility to vote.
    </div>
  );
}

export default RestorationDisclaimer;
